// Money formatting helper used across the storefront. Pure utility — no
// external dependencies. (Previously lived in lib/shopify.js, now removed.)
export const formatMoney = (amount, currency = 'AUD') => {
  const n = typeof amount === 'string' ? parseFloat(amount) : amount;
  try {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `$${Math.round(n).toLocaleString()}`;
  }
};
